const analysisResult = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M13.768 7.558c.104-.422.158-.855.16-1.29A4.078 4.078 0 0 0 10.069 2a3.998 3.998 0 0 0-3.638 2.759 2.719 2.719 0 0 0-1.86-.76 3.069 3.069 0 0 0-2.898 3.209 3.379 3.379 0 0 0 0 .55 3.279 3.279 0 0 0-1.67 2.958 3.139 3.139 0 0 0 2.999 3.28h9.996a3.139 3.139 0 0 0 2.999-3.28 3.199 3.199 0 0 0-2.23-3.158M8.59 8.648v3.468H7.41V8.647H5.231L8 5.878l2.769 2.77z"/></svg>',
};

export { analysisResult as default };
